module.exports = __webpack_public_path__ + "static/icon-tresata-f9874de99938b7dba26df47873bb4a6d.svg";